export default {
  // 外链详情
  getOuterLinkById: '/amc/client/getOuterLinkById',
}